import { render, staticRenderFns } from "./BaseFormRender.vue?vue&type=template&id=0e88f4ef&scoped=true"
import script from "./BaseFormRender.vue?vue&type=script&lang=js"
export * from "./BaseFormRender.vue?vue&type=script&lang=js"
import style0 from "./BaseFormRender.vue?vue&type=style&index=0&id=0e88f4ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e88f4ef",
  null
  
)

export default component.exports